import './plugins/docReady';

import 'lazysizes';

import 'owl.carousel/dist/owl.carousel.min';
import 'owl.carousel/dist/assets/owl.carousel.min.css';

// import 'aos/dist/aos.css';
// import AOS from 'aos';

import './plugins/mobile/jquery-simple-mobilemenu';

((
    ($) => {
        $(document).ready(function () {

        });

        let _header = $('.header');
        let _headerHeight = _header.outerHeight();
        if ($(window).scrollTop() >= _headerHeight) {
            $('body').css('padding-top', _headerHeight);
            _header.addClass('sticky');
        } else {
            $('body').css('padding-top', '');
            _header.removeClass('sticky');
        }

        $(window).scroll(function () {
            var scroll = $(window).scrollTop();
            if (scroll >= _headerHeight) {
                $('body').css('padding-top', _headerHeight);
                _header.addClass('sticky');
            } else {
                $('body').css('padding-top', '');
                _header.removeClass('sticky');
            }
        });

        let targets = $('.js-animate');

        if (targets.length) {
            let options = {
                root: null,
                rootMargin: '0px',
                threshold: 0.5
            };

            let observer = new IntersectionObserver((entries, observer) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        if (!$(entry.target).hasClass('activated')) {
                            $(entry.target).addClass('activated');
                            const animationClass = $(entry.target).attr('data-animation');
                            $(entry.target).addClass(animationClass + ' animate__animated animate__slow activated aos-animate');
                        }
                    }
                });
            }, options);

            targets.each(target => {
                observer.observe(targets[target]);
            });
        }


        // AOS.init();
    }
)
(jQuery));

docReady(() => {

    $(document).ready(function () {
        if ($(window).width() <= 1100) {
            $(".menu-inner").addClass("mobile-menu");
            $(".mobile-menu").simpleMobileMenu({
                onMenuLoad: function (menu) {
                    console.log(menu)
                    console.log("menu loaded")
                },
                onMenuToggle: function (menu, opened) {
                    console.log(opened)
                },
                "menuStyle": "slide"
            });
        }
    });

    $(".burger").click(function () {
        if ($('.burger').hasClass("active")) {
            $(this).removeClass('active');
            $(".sm_menu_outer").removeClass("active");
            $("body").removeClass("mmactive");
        } else {
            $(this).toggleClass('active');
            $(".sm_menu_outer").addClass("active");
            $("body").toggleClass("mmactive");
        }
    });

    $(".social-list").addClass("hide").removeClass("show");
    $('.tabbar ul li .mini-item').on('click touch', function (e) {
        var self = $(this);
        if (!self.parent().hasClass('active')) {
            self.parent().parent().children('li').removeClass('active');
            self.parent().addClass('active');
            var offset = self.parent().position().left + self.parent().width() / 2;
            self.parent().parent().parent().children('em').css("transform", `translateX(${offset}px)`);
        }
    });
    $('#mobile-social-list').click(function () {
        if ($(".social-list").hasClass("hide")) {
            $(".social-list").stop().addClass("show").removeClass("hide");
            return;
        } else {
            $(".social-list").stop().addClass("hide").removeClass("show");
            return;
        }
    });

    document.addEventListener('lazybeforeunveil', function (e) {
        var bg = e.target.getAttribute('data-bg');
        if (bg) {
            e.target.style.backgroundImage = 'url(' + bg + ')';
        }
    });

    let _lottie_loaded = false;
    let _page_loaded = false;
    if (!_page_loaded) {
        $('html').on('mousemove click touchstart touchmove', function (e) {
            if (!_lottie_loaded) {
                const _url = application.lottie_url;
                var lottieScript = document.createElement('script');
                lottieScript.setAttribute('src', _url);
                lottieScript.setAttribute('async', 'async');
                document.head.appendChild(lottieScript);

                _lottie_loaded = true;
            }
            _page_loaded = true;
        });
    }
});